export default {
  methods: {
    stringify_entry(entry) {
      if (typeof entry === 'string') return entry;
      if (entry === null || entry === undefined) return '';
      return typeof entry === 'object' ? JSON.stringify(entry) : String(entry);
    },

    get_base_descriptions(section) {
      if (Array.isArray(section.descriptions)) return section.descriptions;
      return section.description ? [section.description] : [];
    },

    dedupe_description_list(descriptions) {
      const deduped = [];
      const seen = new Set();
      descriptions.forEach((desc) => {
        const reduced = (desc || '').replace(/\s+/g, ' ').trim();
        const fingerprint = reduced.toLowerCase();
        if (!reduced) {
          if (!deduped.length) deduped.push('');
          return;
        }
        if (!seen.has(fingerprint)) {
          seen.add(fingerprint);
          deduped.push(reduced);
        }
      });
      return deduped.length ? deduped : [''];
    },

    build_normalized_section(section, index, fallback_prefix) {
      const base = this.get_base_descriptions(section);
      const normalized = base.length ? base.map((e) => this.stringify_entry(e)) : [''];
      const final = this.dedupe_description_list(normalized);
      return {
        ...section,
        title: section.title || `${fallback_prefix} ${index + 1}`,
        descriptions: final,
        show_on_advert: section.show_on_advert !== false,
      };
    },

    normalize_sections(sections = [], fallback_prefix = 'Section') {
      if (!Array.isArray(sections)) return [];
      return sections.map((s, i) => this.build_normalized_section(s || {}, i, fallback_prefix));
    },

    dedupe_global_description(global_desc = '', sections = []) {
      if (!global_desc || typeof global_desc !== 'string') return '';
      const trimmed = global_desc.replace(/\s+/g, ' ').trim();
      if (!trimmed || trimmed.length > 800) return '';
      const fingerprint = trimmed.toLowerCase();
      const all_text = sections
        .flatMap((s) => s.descriptions || [])
        .map((d) => (d || '').replace(/\s+/g, ' ').trim().toLowerCase())
        .join(' ');
      if (all_text.includes(fingerprint) || fingerprint.includes(all_text.slice(0, 500))) return '';
      return trimmed;
    },
  },
};
